import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Fragment } from 'react';
import { FlightDetailsFooter, FlightDetailsHeader, FlightDetailsInfoBox, FlightDetailsSegment, FlightDetailsStopoverInfoBox } from '../../../components/FlightDetails/index.js';
import { FlightDetailsContainer } from '../../../components/FlightDetailsContent/components/FlightDetailsContainer.js';
import { createFlightSegmentInfo } from '../../../components/FlightDetailsContent/utils/createFlightSegmentInfo.js';
import { calculateTotalFlightDuration, validateRequiredFlightData } from '../../../components/FlightDetailsContent/utils/flightCalculations.js';
import { formatAirportIata } from '../../../components/FlightDetailsContent/utils/formatAirportIata.js';
import { dateTime, dateWithWeekdayFullName, diffInCalendarDays, formatMinutesAsDuration } from '../../../utils/index.js';
export const FlightRoute = ({
  direction,
  flights
}) => {
  const {
    t
  } = useTranslation('travelDetailsOverlay');
  const flightDepartureDateTime = flights[0]?.departureDateTime;
  const flightArrivalDateTime = flights[flights.length - 1]?.arrivalDateTime;
  const arrivalNextDay = diffInCalendarDays(flightDepartureDateTime, flightArrivalDateTime) > 0;
  const isFlightDataValid = validateRequiredFlightData(flights);
  const totalFlightDuration = calculateTotalFlightDuration(flights);
  return _jsxs(FlightDetailsContainer, {
    direction: direction,
    "data-testid": `shared-flightLayer-${direction}Flight`,
    children: [_jsx(FlightDetailsHeader, {
      direction: direction,
      title: `${t(direction === 'outbound' ? 'departureFrom' : 'returnFlightFrom')} ${flights[0].departureCity || flights[0].departureAirportName}`,
      date: flightDepartureDateTime ? dateWithWeekdayFullName(flightDepartureDateTime) : '---',
      showInvalidDataNotice: !isFlightDataValid
    }), flights.map(({
      flightNumber,
      departureCity,
      departureAirportName,
      departureAirportCode,
      departureDateTime,
      arrivalCity,
      arrivalDateTime,
      arrivalAirportName,
      arrivalAirportCode,
      airlineName,
      classFlight,
      duration,
      stayTime = 0,
      changedNextFlightDate = false,
      changedNextFlightAirport
    }, index) => {
      const info = createFlightSegmentInfo({
        airlineName,
        flightNumber,
        cabinClass: classFlight
      });
      return _jsxs(Fragment, {
        children: [_jsx(FlightDetailsSegment, {
          departureTime: departureDateTime ? dateTime(departureDateTime) : '-- : --',
          departureLocation: departureCity || departureAirportName || '--',
          departureIata: formatAirportIata(departureAirportName, departureAirportCode),
          arrivalTime: arrivalDateTime ? dateTime(arrivalDateTime) : '-- : --',
          arrivalLocation: arrivalCity || arrivalAirportName || '--',
          arrivalIata: formatAirportIata(arrivalAirportName, arrivalAirportCode),
          duration: duration ? formatMinutesAsDuration(duration) : '-- h -- min',
          info: info,
          arrivalAlert: diffInCalendarDays(departureDateTime, arrivalDateTime)
        }), stayTime > 0 && _jsx(FlightDetailsStopoverInfoBox, {
          children: _jsx(FlightDetailsInfoBox, {
            stayTime: formatMinutesAsDuration(stayTime),
            changedNextFlightDate: changedNextFlightDate,
            children: changedNextFlightAirport ? `${t('transferAt')} ${changedNextFlightAirport}` : t('stopover')
          })
        })]
      }, index);
    }), _jsx(FlightDetailsFooter, {
      date: flightArrivalDateTime ? dateWithWeekdayFullName(flightArrivalDateTime) : '---',
      arrivalNextDay: arrivalNextDay,
      duration: totalFlightDuration ? formatMinutesAsDuration(totalFlightDuration) : '-- h -- min',
      durationLabel: t('totalTravelTime')
    })]
  });
};